module.exports = __webpack_public_path__ + "media/images/kraft-heinz-logo-7d6fc4d3717898495b4473354b4d3e3b.png";